import { render, staticRenderFns } from "./ReportAsCompanyDropdown.vue?vue&type=template&id=504835c8&scoped=true"
import script from "./ReportAsCompanyDropdown.vue?vue&type=script&lang=js"
export * from "./ReportAsCompanyDropdown.vue?vue&type=script&lang=js"
import style0 from "./ReportAsCompanyDropdown.vue?vue&type=style&index=0&id=504835c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504835c8",
  null
  
)

export default component.exports